import React, { memo } from 'react';
import { withNativeProps } from '../../utils/native-props';
export var PlaceholderIcon = /*#__PURE__*/memo(function (props) {
  return withNativeProps(props, /*#__PURE__*/React.createElement("svg", {
    width: "1em",
    height: "1em",
    viewBox: "0 0 64 64",
    fill: "currentColor"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M38.2858 18.8572L56.1012 49.7143H20.4704L38.2858 18.8572Z"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M18.2855 30.8572L29.1727 49.7143H7.39836L18.2855 30.8572Z"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: "21.714",
    cy: "18.2857",
    r: "5.71428"
  })));
});